'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { getStoryRepository } from '@/contexts/stories/repositories';

export interface ToggleFavoriteData {
  isFavorite: boolean;
  favoritedAt: string | null;
}

export async function toggleFavorite(
  storyId: string
): Promise<ActionResult<ToggleFavoriteData>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    const result = await getStoryRepository().toggleFavorite(storyId, familyId);

    return {
      success: true,
      data: {
        isFavorite: result.isFavorite,
        favoritedAt: result.favoritedAt
          ? result.favoritedAt.toISOString()
          : null,
      },
    };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('toggleFavorite', e) };
  }
}
